
export const environment = {
  production: true,
  baseUrl: "https://yoklamaservices.ankara.edu.tr/api",
  //baseUrl: "http://92.61.14.135:5278/api",
  fileUrl: "http://localhost:5278/",
  basicAuthUser:"mobil",
  basicAuthPasword:'!fS42m*!',
  version:"1.1.7",
};
